export interface PasswordValidationResult {
    isValid: boolean;
    errors: string[];
}

export const validatePassword = (
    password: string,
): PasswordValidationResult => {
    const errors: string[] = [];

    // Check minimum length
    if (password.length < 8) {
        errors.push("Password must be at least 8 characters long");
    }

    // Check maximum length (AWS Cognito limit)
    if (password.length > 256) {
        errors.push("Password must not exceed 256 characters");
    }

    // Check for whitespace at beginning or end
    if (/^\s/.test(password) || /\s$/.test(password)) {
        errors.push("Password cannot start or end with whitespace");
    }

    // Check for uppercase letter
    if (!/[A-Z]/.test(password)) {
        errors.push("Password must contain at least one uppercase letter");
    }

    // Check for lowercase letter
    if (!/[a-z]/.test(password)) {
        errors.push("Password must contain at least one lowercase letter");
    }

    // Check for number
    if (!/[0-9]/.test(password)) {
        errors.push("Password must contain at least one number");
    }

    // Check for special character (matching the original regex)
    if (!/[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]/.test(password)) {
        errors.push("Password must contain at least one special character");
    }

    return {
        isValid: errors.length === 0,
        errors,
    };
};

export const validatePasswordMatch = (
    password: string,
    confirmPassword: string,
): boolean => {
    return password === confirmPassword;
};

// Helper function for legacy compatibility with PasswordRequirementsError component
export const isPasswordValid = (password: string): boolean => {
    const result = validatePassword(password);
    return result.isValid;
};
